import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker as MuiDateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { Grid } from "@mui/material";

dayjs.extend(utc);

const DateTimePicker = (props) => {
  const { value, size, onChange, disabledField, height, ...otherProps } = props;

  const [dateSelected, setDateSelected] = useState(null);
  const [error, setError] = useState(null);

  const handleChange = (date) => {
    if (date === null) {
      setError(null);
      setDateSelected(null);
      onChange(null);
    } else {
      if (!date.isValid()) {
        setError("Invalid Date");
      } else {
        setError(null);
        setDateSelected(date);
        onChange(date.utc().format("YYYY-MM-DDTHH:mm:ss"));
      }
    }
  };

  useEffect(() => {
    setDateSelected(value ? dayjs.utc(value).local() : null);
  }, [value]);

  return (
    <Grid sx={{ display: "flex" }} direction="column">
      <Grid sx={{ display: "flex" }} direction="row" alignItems="center">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <MuiDateTimePicker
            onChange={handleChange}
            disabled={
              otherProps?.type === "preview" || disabledField ? true : false
            }
            slotProps={{
              textField: {
                helperText: error,
                ...(height === "small" ? { size: "small" } : {}),
              },
              field: { clearable: true },
            }}
            value={dateSelected}
            sx={{
              "& ::placeholder": {
                color: "rgba(215, 215, 215, 1)",
              },
              mt: 1,
              width: size ? `${size * 8}px` : "100%",
            }}
            {...otherProps}
          />
        </LocalizationProvider>
      </Grid>
    </Grid>
  );
};

export default DateTimePicker;
